"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lendingClubLogo = _interopRequireDefault(require("./lending-club-logo.svg"));
var _util = require("../../../util");
var _base = _interopRequireDefault(require("../../atomic/texts/base"));
require("./styles.scss");
var _constants = require("./constants");
var _currentStep = _interopRequireDefault(require("./current-step"));
var _completedStep = _interopRequireDefault(require("./completed-step"));
var _incompleteStep = _interopRequireDefault(require("./incomplete-step"));
var BLOCK_CLASS = 'pf-site-header';
var bem = (0, _util.klass)(BLOCK_CLASS);
var map = new Map([[_constants.ApplicationSteps.COMPLETED, function () {
  return /*#__PURE__*/_react.default.createElement(_completedStep.default, null);
}], [_constants.ApplicationSteps.CURRENT, function (step) {
  return /*#__PURE__*/_react.default.createElement(_currentStep.default, {
    step: step
  });
}], [_constants.ApplicationSteps.INCOMPLETE, function (step) {
  return /*#__PURE__*/_react.default.createElement(_incompleteStep.default, {
    step: step
  });
}]]);
var Header = function Header(_ref) {
  var logoHREF = _ref.logoHREF,
    logo = _ref.logo,
    brand = _ref.brand,
    statuses = _ref.statuses;
  return /*#__PURE__*/_react.default.createElement("header", {
    className: BLOCK_CLASS
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: bem('logo')
  }, /*#__PURE__*/_react.default.createElement(_base.default, {
    as: "a",
    href: logoHREF
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "Lending Club Logo"
  }))), /*#__PURE__*/_react.default.createElement(_base.default, {
    className: bem('brand')
  }, brand), statuses && /*#__PURE__*/_react.default.createElement("ul", {
    className: bem('statuses')
  }, statuses.map(function (status, idx) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: status.text
    }, map.has(status.icon) ? map.get(status.icon)(idx + 1) : /*#__PURE__*/_react.default.createElement("img", {
      src: status.icon,
      alt: "".concat(status.text, " icon")
    }), /*#__PURE__*/_react.default.createElement(_base.default, null, status.text));
  })));
};
Header.propTypes = {
  logoHREF: _propTypes.default.string.isRequired,
  logo: _propTypes.default.node,
  brand: _propTypes.default.string.isRequired,
  statuses: _propTypes.default.arrayOf(_propTypes.default.shape({
    // Type "node" is here just to be backwards compatible.
    // We will delete the actual SVG files in favor of the components.
    icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
    text: _propTypes.default.string
  }))
};
Header.defaultProps = {
  logo: _lendingClubLogo.default,
  statuses: null
};
var _default = Header;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');